// 1 час 20 tgem, каждые 3 минуты 1 tgem
export const calculateInstantCompleteValue = (timeLeft: number): number =>
  Math.ceil(timeLeft / 180);
